export default __webpack_public_path__ + "static/media/kitchen2-1024w.9767c2d5.webp";